import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cover-setting-container" }
const _hoisted_2 = { class: "header-action-bar" }
const _hoisted_3 = { class: "title-group" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "btns" }
const _hoisted_6 = { class: "cover-layout" }
const _hoisted_7 = { class: "cover-form-area" }
const _hoisted_8 = { class: "form-section-block" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "form-row triple-row" }
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = { class: "form-section-block" }
const _hoisted_13 = { class: "form-row" }
const _hoisted_14 = { class: "form-row geolocation-row" }
const _hoisted_15 = { class: "form-row" }
const _hoisted_16 = { class: "form-section-block" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-row triple-row" }
const _hoisted_19 = { class: "form-row" }
const _hoisted_20 = { class: "rate-wrapper" }
const _hoisted_21 = { class: "rate-text" }
const _hoisted_22 = { class: "form-section-block" }
const _hoisted_23 = { class: "media-setting-box" }
const _hoisted_24 = { class: "media-item-box" }
const _hoisted_25 = { class: "media-item-info" }
const _hoisted_26 = { class: "label-text" }
const _hoisted_27 = { class: "upload-area-wrapper" }
const _hoisted_28 = {
  key: 0,
  class: "avatar-preview-box"
}
const _hoisted_29 = { class: "hover-mask" }
const _hoisted_30 = {
  key: 1,
  class: "upload-placeholder"
}
const _hoisted_31 = { class: "media-item-box column-layout" }
const _hoisted_32 = { class: "media-item-info" }
const _hoisted_33 = { class: "label-text" }
const _hoisted_34 = { class: "slideshow-container" }
const _hoisted_35 = { class: "slideshow-mask" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "form-section-block" }
const _hoisted_38 = { class: "cover-preview-area" }
const _hoisted_39 = { class: "preview-header" }
const _hoisted_40 = { class: "mockup-phone" }
const _hoisted_41 = { class: "phone-screen" }
const _hoisted_42 = { class: "app_icon" }
const _hoisted_43 = { class: "back-circle" }
const _hoisted_44 = { class: "more-circle" }
const _hoisted_45 = { class: "app_cover" }
const _hoisted_46 = { class: "screen-scroll-container" }
const _hoisted_47 = { class: "author_info" }
const _hoisted_48 = { class: "mock-game-title" }
const _hoisted_49 = { class: "mock-author" }
const _hoisted_50 = {
  key: 0,
  class: "category-chip"
}
const _hoisted_51 = { class: "about-card" }
const _hoisted_52 = { class: "section-sub-title" }
const _hoisted_53 = { class: "spec-list" }
const _hoisted_54 = { class: "spec-item" }
const _hoisted_55 = { class: "spec-label" }
const _hoisted_56 = { class: "spec-item" }
const _hoisted_57 = { class: "spec-label" }
const _hoisted_58 = { class: "spec-val" }
const _hoisted_59 = { class: "spec-item" }
const _hoisted_60 = { class: "spec-label" }
const _hoisted_61 = { class: "spec-val truncate" }
const _hoisted_62 = { class: "introduce-card" }
const _hoisted_63 = { class: "section-sub-title" }
const _hoisted_64 = { class: "introduce-text" }
const _hoisted_65 = { class: "mock-bottom-bar" }
const _hoisted_66 = { class: "start-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Check = _resolveComponent("Check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_DeleteFilled = _resolveComponent("DeleteFilled")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_VueDraggable = _resolveComponent("VueDraggable")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_More = _resolveComponent("More")!
  const _component_User = _resolveComponent("User")!
  const _component_AlarmClock = _resolveComponent("AlarmClock")!
  const _component_Location = _resolveComponent("Location")!
  const _component_Right = _resolveComponent("Right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("edit.cover.title") || "游戏基本信息与封面包装"), 1),
        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "sub-title" }, "配置游戏对外公开的名片信息、地理动线、多媒体画廊与故事背景", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          size: "large",
          type: "primary",
          onClick: _ctx.handleSave,
          class: "save-top-btn",
          loading: _ctx.saving
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Check)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("edit.cover.save") || "保存配置"), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          "label-position": "top",
          class: "clean-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "section-title-row" }, [
                _createElementVNode("span", { class: "indicator-bar" }),
                _createElementVNode("span", { class: "section-name" }, "核心基本信息")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.gameTitle'),
                  class: "flex-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.gameTitle,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.gameTitle) = $event)),
                      placeholder: "例如：迷失老城的钟楼秘钥",
                      size: "large",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: "游戏创作者/团队",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.author,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.author) = $event)),
                      placeholder: "创作者或团队署名",
                      size: "large",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.area')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_cascader, {
                      placeholder: "请选择落地地区",
                      style: {"width":"100%"},
                      modelValue: _ctx.form.region,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.region) = $event)),
                      options: _ctx.selectRegion,
                      size: "large",
                      clearable: "",
                      onChange: _ctx.handleChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.gameLanguage')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.gameLanguage,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.gameLanguage) = $event)),
                      size: "large",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "繁体中文",
                          value: "繁体中文"
                        }),
                        _createVNode(_component_el_option, {
                          label: "简体中文",
                          value: "简体中文"
                        }),
                        _createVNode(_component_el_option, {
                          label: "English",
                          value: "English"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: "游戏分类",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.gameCategory,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.gameCategory) = $event)),
                      size: "large",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "城市探索",
                          value: "城市探索"
                        }),
                        _createVNode(_component_el_option, {
                          label: "博物馆",
                          value: "博物馆"
                        }),
                        _createVNode(_component_el_option, {
                          label: "线上解谜",
                          value: "线上解谜"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.gameCategory'),
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.gameClass,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.gameClass) = $event)),
                      size: "large",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "单人角色剧本",
                          value: "单人角色剧本"
                        }),
                        _createVNode(_component_el_option, {
                          label: "多人角色剧本",
                          value: "多人角色剧本"
                        }),
                        _createVNode(_component_el_option, {
                          label: "亲子互动",
                          value: "亲子互动"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.tag'),
                  class: "flex-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.tips,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.tips) = $event)),
                      multiple: "",
                      filterable: "",
                      "allow-create": "",
                      "multiple-limit": "5",
                      "default-first-option": "",
                      placeholder: "选择或输入标签后回车（最多5个）",
                      size: "large",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[32] || (_cache[32] = _createElementVNode("div", { class: "section-title-row" }, [
                _createElementVNode("span", { class: "indicator-bar" }),
                _createElementVNode("span", { class: "section-name" }, "地理位置与实景动线")
              ], -1)),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_form_item, {
                  label: "核心地标 / 场所名称",
                  class: "flex-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.placeName,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.placeName) = $event)),
                      placeholder: "具体定位场所（例如：天后宫前街、科技馆主展厅）",
                      size: "large",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "中心经度 (Lng)",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.log,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.log) = $event)),
                      placeholder: "113.123456",
                      size: "large",
                      clearable: ""
                    }, {
                      suffix: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          placement: "top"
                        }, {
                          content: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createTextVNode(" 如何获取经纬度：", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 方法：通过高德开放平台（精确获取）", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 如果你需要批量或精确获取坐标，可以使用高德地图的坐标拾取器：", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 1. 访问高德坐标拾取器 ", -1),
                            _createElementVNode("a", {
                              href: "https://lbs.amap.com/tools/picker",
                              target: "_blank",
                              style: {"color":"red"}
                            }, "https://lbs.amap.com/tools/picker", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 2. 在搜索框输入地址，或直接在地图上点击", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 3. 左侧会显示对应的经纬度坐标", -1),
                            _createElementVNode("br", null, null, -1)
                          ]))]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, { class: "coord-help-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_QuestionFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "中心纬度 (Lat)",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.lat,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.lat) = $event)),
                      placeholder: "23.123456",
                      size: "large",
                      clearable: ""
                    }, {
                      suffix: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          placement: "top"
                        }, {
                          content: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                            _createTextVNode(" 如何获取经纬度：", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 方法：通过高德开放平台（精确获取）", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 如果你需要批量或精确获取坐标，可以使用高德地图的坐标拾取器：", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 1. 访问高德坐标拾取器 ", -1),
                            _createElementVNode("a", {
                              href: "https://lbs.amap.com/tools/picker",
                              target: "_blank",
                              style: {"color":"red"}
                            }, "https://lbs.amap.com/tools/picker", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 2. 在搜索框输入地址，或直接在地图上点击", -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 3. 左侧会显示对应的经纬度坐标", -1),
                            _createElementVNode("br", null, null, -1)
                          ]))]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, { class: "coord-help-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_QuestionFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.address')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.merchantAddress,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.merchantAddress) = $event)),
                    placeholder: "请输入完整详细地址，供玩家导航参考",
                    size: "large",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.begin'),
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.beginPoint,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.beginPoint) = $event)),
                      placeholder: "例如：景区东门游客接待中心",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.end'),
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.endPoint,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.endPoint) = $event)),
                      placeholder: "例如：钟楼广场西侧出口",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.Facilities_along_way')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.along,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.along) = $event)),
                      placeholder: "沿途洗手间、便利店、无障碍通道等说明",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.transportation')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.transportation,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.transportation) = $event)),
                      placeholder: "例如：地铁2号线直达，建议步行参与",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "section-title-row" }, [
                _createElementVNode("span", { class: "indicator-bar" }),
                _createElementVNode("span", { class: "section-name" }, "游玩规格与规则建议")
              ], -1)),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.opening_hours')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.openHour,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.openHour) = $event)),
                      placeholder: "例如: 09:00 - 18:00 (17:00停止入场)",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.experience_time')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.experienceTime,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.experienceTime) = $event)),
                      placeholder: "例如: 全年开放 / 每周二至周日",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.walking_distance')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.walk,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.walk) = $event)),
                      placeholder: "公里数",
                      size: "large"
                    }, {
                      append: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode("km", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.estimated_time')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.estimateTime,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.estimateTime) = $event)),
                      placeholder: "耗时描述",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.player_age')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.playerAge,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.playerAge) = $event)),
                      placeholder: "例如: 8岁以上 / 全年龄",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.difficulty'),
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_rate, {
                        modelValue: _ctx.form.difficulty,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.difficultyLabel), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('edit.cover.playTime'),
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.form.playTime,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.playTime) = $event)),
                      min: 10,
                      max: 240,
                      step: 10,
                      size: "large",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "section-title-row" }, [
                _createElementVNode("span", { class: "indicator-bar" }),
                _createElementVNode("span", { class: "section-name" }, "多媒体资源视觉配置")
              ], -1)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("edit.cover.gameCover")), 1),
                    _cache[35] || (_cache[35] = _createElementVNode("p", { class: "desc-text" }, " 游戏在大厅与列表卡片展示的核心封面图。推荐比例 4:3，支持 JPG/PNG/WEBP (5MB 内) ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_el_upload, {
                      class: "avatar-uploader",
                      action: _ctx.UpdateApi,
                      "show-file-list": false,
                      "on-success": _ctx.handleAvatarSuccess,
                      "before-upload": _ctx.beforeAvatarUpload,
                      limit: 1,
                      "file-list": _ctx.fileList,
                      disabled: _ctx.allowUpload
                    }, {
                      default: _withCtx(() => [
                        (_ctx.form.gameCover)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createVNode(_component_el_image, {
                                src: _ctx.form.gameCover,
                                class: "avatar",
                                alt: "游戏封面",
                                fit: "cover"
                              }, null, 8, ["src"]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("span", {
                                  class: "del-btn",
                                  onClick: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)), ["stop"])),
                                  title: "删除并重新上传"
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DeleteFilled)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Plus)
                                ]),
                                _: 1
                              }),
                              _cache[36] || (_cache[36] = _createElementVNode("span", { class: "up-txt" }, "上传封面图", -1))
                            ]))
                      ]),
                      _: 1
                    }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("edit.cover.slideshow")), 1),
                    _cache[37] || (_cache[37] = _createElementVNode("p", { class: "desc-text" }, " 移动端详情页展示的多图相册。最多上传 5 张，可长按或拖拽卡片调整展示顺序 ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_VueDraggable, {
                      ref: "el",
                      modelValue: _ctx.fileList2,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.fileList2) = $event)),
                      class: "slideshow-draggable",
                      animation: 150
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList2, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.uid || index,
                            class: "slideshow-card"
                          }, [
                            _createVNode(_component_el_image, {
                              src: item.url,
                              fit: "cover",
                              class: "slideshow-image"
                            }, null, 8, ["src"]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("span", {
                                class: "del-btn-round",
                                onClick: _withModifiers(($event: any) => (_ctx.clearImage2(index)), ["stop"]),
                                title: "删除此图"
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DeleteFilled)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_36)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.fileList2.length < 5)
                      ? (_openBlock(), _createBlock(_component_el_upload, {
                          key: 0,
                          "file-list": _ctx.fileList2,
                          action: _ctx.UpdateApi,
                          "on-success": _ctx.handleAvatarSuccess2,
                          "before-upload": _ctx.beforeAvatarUpload2,
                          "show-file-list": false,
                          "list-type": "picture-card",
                          class: "slideshow-uploader"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["file-list", "action", "on-success", "before-upload"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "section-title-row" }, [
                _createElementVNode("span", { class: "indicator-bar" }),
                _createElementVNode("span", { class: "section-name" }, "背景故事与详细介绍")
              ], -1)),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.gameDescription')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.gameDesc,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.gameDesc) = $event)),
                    type: "textarea",
                    placeholder: "请详细描述游戏的故事背景、玩家使命与核心探索看点...",
                    size: "large",
                    rows: "6",
                    "show-word-limit": "",
                    maxlength: "500"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.research_characteristics')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.features,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.features) = $event)),
                    type: "textarea",
                    placeholder: "描述其独有的研学意义、团队协作或空间文化探索特性...",
                    size: "large",
                    rows: "4",
                    "show-word-limit": "",
                    maxlength: "300"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.introduction')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.introductionLink,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.introductionLink) = $event)),
                    placeholder: "外部参考链接、公众号推文或全景VR外链 (选填)",
                    size: "large",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "badge-dot" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("edit.cover.titleApp") || "App 详情页实时视口"), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _cache[42] || (_cache[42] = _createElementVNode("div", { class: "phone-top-bar" }, [
            _createElementVNode("div", { class: "notch" })
          ], -1)),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("span", _hoisted_43, [
                _createVNode(_component_el_icon, {
                  size: "14",
                  color: "#ffffff"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowLeft)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("span", _hoisted_44, [
                _createVNode(_component_el_icon, {
                  size: "14",
                  color: "#ffffff"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_More)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_el_image, {
                class: "cover-img",
                src: 
                  _ctx.form.gameCover ||
                  'https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493'
                ,
                fit: "cover"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("h4", _hoisted_48, _toDisplayString(_ctx.form.gameTitle || "未命名游戏"), 1),
                _createElementVNode("p", _hoisted_49, [
                  _createVNode(_component_el_icon, { class: "author-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_User)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" By " + _toDisplayString(_ctx.form.author || "平台创作者"), 1)
                ]),
                (_ctx.form.gameClass)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.form.gameClass), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("h5", _hoisted_52, _toDisplayString(_ctx.$t("edit.cover.app1") || "基本概况"), 1),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_el_icon, { class: "spec-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("edit.cover.app2") || "难度") + "：", 1),
                    _createVNode(_component_el_rate, {
                      modelValue: _ctx.form.difficulty,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                      disabled: "",
                      size: "small"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_el_icon, { class: "spec-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AlarmClock)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("edit.cover.app3") || "预计用时") + "：", 1),
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.form.playTime) + " 分钟", 1)
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_el_icon, { class: "spec-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Location)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t("edit.cover.app4") || "起点位置") + "：", 1),
                    _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.form.placeName || _ctx.form.beginPoint || "具体地点待定"), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("h5", _hoisted_63, _toDisplayString(_ctx.$t("edit.cover.app5") || "剧情与体验简介"), 1),
                _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.form.gameDesc || "暂无游戏介绍，请在左侧表单输入。"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "开启实景探索", -1)),
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Right)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ]))
}